// src/services/apiService.js
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:8080";

export const apiService = {
  async checkHealth() {
    const response = await fetch(`${API_BASE_URL}/api/health`);
    if (!response.ok) throw new Error("Health check failed");
    return await response.json();
  },

  async testVideoSource(url) {
    const response = await fetch(`${API_BASE_URL}/api/detection/test-source`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url }),
    });
    return await response.json();
  },

  async startDetection(url, confidenceThreshold, highRiskThreshold) {
    const response = await fetch(`${API_BASE_URL}/api/detection/start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        url,
        confidence_threshold: confidenceThreshold,
        high_risk_threshold: highRiskThreshold,
      }),
    });
    return await response.json();
  },

  async stopDetection() {
    const response = await fetch(`${API_BASE_URL}/api/detection/stop`, {
      method: "POST",
    });
    if (!response.ok) throw new Error("Stop detection failed");
    return await response.json();
  },

  async getDetectionStatus() {
    const response = await fetch(`${API_BASE_URL}/api/detection/status`);
    if (!response.ok) throw new Error("Get status failed");
    return await response.json();
  },

  async getDetectionResults(limit = 8) {
    const response = await fetch(
      `${API_BASE_URL}/api/detection/results?limit=${limit}`
    );
    if (!response.ok) throw new Error("Get results failed");
    return await response.json();
  },

  async getDetectionSummary() {
    const response = await fetch(`${API_BASE_URL}/api/detection/summary`);
    if (!response.ok) throw new Error("Get summary failed");
    return await response.json();
  },

  async analyzeImage(file, confidenceThreshold) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("confidence_threshold", confidenceThreshold.toString());

    const response = await fetch(`${API_BASE_URL}/api/detection/single-image`, {
      method: "POST",
      body: formData,
    });
    return await response.json();
  },

  getVideoStreamUrl() {
    return `${API_BASE_URL}/api/stream/video?t=${Date.now()}`;
  },
};
